import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import styles, { releaseCardStyle } from "../styles";
import { stackCenterGap } from "../../../styles/utilStyles";
import { getHeaders } from "../../../utils/apiclient";
import ActionButton from "./ActionButton";
import { toTitleCase } from "../../../utils/helperFunctions";

const ReleasesLabelItem = ({
  release,
  releaseLabel,
  app,
  showReleaseStatusDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box sx={releaseCardStyle.releaseLabelStack(colors)}>
      <Box sx={{ p: "10px" }}>
        <Typography variant="h5" sx={styles.inlineBoldText}>
          {releaseLabel?.name}
        </Typography>
      </Box>

      <Typography
        variant="h6"
        sx={releaseCardStyle.releaseLabelStatus(releaseLabel?.status)}
      >
        {toTitleCase(releaseLabel.status)?.replace("Qa", "QA")}
      </Typography>
      <Box sx={stackCenterGap} />
      {releaseLabel?.actionsAllowed?.map((action) => (
        <ActionButton
          action={action}
          path={`/apps/${app}/releases/${release?.name}/release-labels/${releaseLabel?.name}`}
          onClick={() =>
            showReleaseStatusDialog(
              `Perform action ${action} on release-label ${releaseLabel?.name}`,
              `/${release?.name}/release-labels/${releaseLabel?.name}`,
              { headers: { ...getHeaders(), Action: action } }
            )
          }
        />
      ))}
    </Box>
  );
};

export default ReleasesLabelItem;
